























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import BaseComponent from '@/core/base.component';
import { MenuCreateDto } from '@/dto';
import BrandService from '@/services/brand.service';
import MenuService from '@/services/menu.service';
import FileUploadService, {
  UPLOAD_TYPE,
} from '@/services/shared/file-upload/file-upload.service';
import toast from '../../../../resources/assets/js/services/toast.js';
import { CONST_YN, YN } from '@/common';
import {
  ATTACHMENT_REASON_TYPE,
  FileAttachmentDto,
} from '@/services/shared/file-upload';

@Component({
  name: 'MenuCreate',
})
export default class MenuCreate extends BaseComponent {
  @Prop() readonly brandNo: number;
  private menuCreateDto = new MenuCreateDto();
  private proppedBrandNo = true;
  private showYn: YN[] = [...CONST_YN];
  private attachments: FileAttachmentDto[] = [];

  deleteImages(image) {
    if (this.attachments.includes(image)) {
      const index = this.attachments.indexOf(image);
      if (index > -1) {
        this.attachments.splice(index, 1);
      }
    }
  }

  clearOutCreateDto() {
    this.attachments = [];
    this.$refs['fileInput'].reset();
    this.menuCreateDto = new MenuCreateDto();
  }

  create() {
    if (this.brandNo) {
      this.menuCreateDto.brandNo = this.brandNo;
    }
    this.menuCreateDto.images = this.attachments;
    MenuService.create(this.menuCreateDto).subscribe(res => {
      if (res) {
        toast.success('추가 완료');
        this.$root.$emit('menu_create');
      }
    });
  }

  async upload(file: File[]) {
    const attachments = await FileUploadService.upload(UPLOAD_TYPE.MENU, file);
    this.attachments = [];
    this.attachments.push(
      ...attachments.filter(
        fileUpload =>
          fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );
  }

  created() {
    if (this.brandNo) {
      this.proppedBrandNo = true;
    } else {
      this.proppedBrandNo = false;
    }
  }
}
